import type { ApiHandlerContract } from '../../../types/api';
import { ApiService } from '../../../types/api';

/**
 * A service contract to interact with a specific discount via the SparkLayer API.
 */
export interface DiscountApiContract {
  delete(): Promise<void>;
}

/**
 * A service to interact with a specific shipping method via the SparkLayer API.
 */
export class DiscountApi extends ApiService implements DiscountApiContract {
  constructor(
    api: ApiHandlerContract,
    private id: string,
  ) {
    super(api);
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/discounts/{id}',
      params: { id: this.id },
    });
  }
}
